pluginChromeTemplate = require 'views/templates/plugin_chrome'
PluginChromeView = require 'views/plugin/plugin-chrome-view'


module.exports = class PluginModalView extends PluginChromeView
  initialize: ({ @content }) ->
    @retain(@content)

  className: 'plugin-modal'



// WEBPACK FOOTER //
// ./app/scripts/views/plugin/plugin-modal-view.coffee